"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$amendProvision = exports.amendProvisionToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const _paragraphItem_1 = require("./$paragraphItem");
const _preamble_1 = __importStar(require("./$preamble"));
const _articleGroup_1 = __importStar(require("./$articleGroup"));
const _article_1 = __importStar(require("./$article"));
const util_2 = require("../../../util");
const _figStruct_1 = __importStar(require("./$figStruct"));
const _tableStruct_1 = __importStar(require("./$tableStruct"));
const _appdxItem_1 = require("./$appdxItem");
const _supplProvisionAppdxItem_1 = require("./$supplProvisionAppdxItem");
const _list_1 = require("./$list");
const _noteLike_1 = require("./$noteLike");
const _toc_1 = __importStar(require("./$toc"));
const _remarks_1 = __importStar(require("./$remarks"));
const _supplNote_1 = __importStar(require("./$supplNote"));
const el_1 = require("../../../node/el");
/**
 * The renderer for {@link std.AmendProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$amendProvision.spec.ts) for examples.
 */
const amendProvisionToLines = (amendProvision, indentTexts, options) => {
    const { withControl, } = {
        withControl: false,
        ...options,
    };
    const lines = [];
    const newProvisionsIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const child of amendProvision.children) {
        if ((0, std_1.isAmendProvisionSentence)(child)) {
            lines.push(new line_1.OtherLine({
                range: null,
                indentTexts,
                controls: withControl ? [
                    new inline_1.Control(":amend-provision:", null, "", null)
                ] : [],
                sentencesArray: [
                    new inline_1.Sentences("", null, [], child.children),
                ],
                lineEndText: toCSTSettings_1.default.EOL,
            }));
        }
        else if ((0, std_1.isNewProvision)(child)) {
            for (const [cci, cc] of child.children.entries()) {
                if ((0, std_1.isArticle)(cc)) {
                    lines.push(...(0, _article_1.articleToLines)(cc, newProvisionsIndentTexts));
                }
                else if (std.isParagraphItem(cc)) {
                    lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isList)(cc)) {
                    lines.push(...(0, _list_1.listOrSublistToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isTableStruct)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    const withControl = ((0 <= (cci - 1) && (0, std_1.isTableStruct)((child.children[cci - 1]))) ||
                        ((cci + 1) < child.children.length && (0, std_1.isTableStruct)((child.children[cci + 1]))));
                    lines.push(...(0, _tableStruct_1.tableStructToLines)(cc, newProvisionsIndentTexts, { withControl }));
                }
                else if ((0, std_1.isFigStruct)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _figStruct_1.figStructToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isAppdxItem)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _appdxItem_1.appdxItemToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isSupplProvisionAppdxItem)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _supplProvisionAppdxItem_1.supplProvisionAppdxItemToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isNoteLikeStruct)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _noteLike_1.noteLikeStructToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isRemarks)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _remarks_1.remarksToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isSupplNote)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _supplNote_1.supplNoteToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isPreamble)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _preamble_1.preambleToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isTOC)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _toc_1.tocToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isAmendProvision)(cc)) {
                    lines.push(...(0, exports.amendProvisionToLines)(cc, newProvisionsIndentTexts, { withControl: true }));
                }
                else if ((0, std_1.isArticleGroup)(cc)) {
                    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
                    lines.push(...(0, _articleGroup_1.articleGroupToLines)(cc, newProvisionsIndentTexts));
                }
                else if ((0, std_1.isArticleGroupTitle)(cc) || (0, std_1.isLawTitle)(cc)) {
                    lines.push(new line_1.OtherLine({
                        range: null,
                        indentTexts: newProvisionsIndentTexts,
                        controls: [],
                        sentencesArray: [
                            new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, [new el_1.EL("__CapturedXML", {}, [cc])])]),
                        ],
                        lineEndText: toCSTSettings_1.default.EOL,
                    }));
                }
                else {
                    throw new util_2.NotImplementedError(cc.tag);
                }
            }
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.amendProvisionToLines = amendProvisionToLines;
const $newProvisionsBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$newProvisionsBlock", (factory_1.factory
    .choice(c => c
    .or(() => _preamble_1.default)
    .or(() => _toc_1.default)
    .or(() => _articleGroup_1.default)
    .or(() => _article_1.default)
    .or(() => _paragraphItem_1.$requireControlParagraphItem)
    .or(() => _figStruct_1.default)
    .or(() => _tableStruct_1.default)
    .or(() => _noteLike_1.$noteStruct)
    .or(() => _noteLike_1.$styleStruct)
    .or(() => _noteLike_1.$formatStruct)
    .or(() => _list_1.$list)
    .or(() => _appdxItem_1.$appdxFig)
    .or(() => _appdxItem_1.$appdxTable)
    .or(() => _appdxItem_1.$appdxStyle)
    .or(() => _appdxItem_1.$appdxNote)
    .or(() => _appdxItem_1.$appdxFormat)
    .or(() => _appdxItem_1.$appdx)
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdxStyle)
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdxTable)
    .or(() => _supplProvisionAppdxItem_1.$supplProvisionAppdx)
    .or(() => _remarks_1.default)
    .or(() => _supplNote_1.default)
    .or(() => _preamble_1.default)
    .orSequence(s => s
    .andOmit(r => r
    .nextIs(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.some(c => c.control === ":amend-provision:")) {
        return item;
    }
    else {
        return null;
    }
})))
    .and(() => exports.$amendProvision))
    .or(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.line.sentencesArray.length === 1
        && item.line.sentencesArray[0].sentences.length === 1
        && item.line.sentencesArray[0].sentences[0].children.length === 1
        && typeof item.line.sentencesArray[0].sentences[0].children[0] !== "string"
        && item.line.sentencesArray[0].sentences[0].children[0].tag === "__CapturedXML"
        && item.line.sentencesArray[0].sentences[0].children[0].children.length === 1
        && typeof item.line.sentencesArray[0].sentences[0].children[0].children[0] !== "string") {
        const errors = [];
        const el = item.line.sentencesArray[0].sentences[0].children[0].children[0].copy(false);
        return {
            value: el,
            errors,
        };
    }
    else {
        return null;
    }
})))));
/**
 * The parser rule for {@link std.AmendProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$amendProvision.spec.ts) for examples.
 */
exports.$amendProvision = factory_1.factory
    .withName("amendProvision")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH) {
        return item;
    }
    else {
        return null;
    }
}), "line")
    .and(r => r
    .zeroOrOne(() => $newProvisionsBlock), "newProvisions")
    .action(({ line, newProvisions }) => {
    const children = [];
    const errors = [];
    const amendProvisionSentence = (0, std_1.newStdEL)("AmendProvisionSentence", {}, (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(line.line.sentencesArray), line.line.sentencesArrayRange);
    children.push(amendProvisionSentence);
    if (newProvisions) {
        const newProvisionChildren = newProvisions.value.map(c => c.value);
        children.push((0, std_1.newStdEL)("NewProvision", {}, newProvisionChildren, (0, el_1.rangeOfELs)(newProvisionChildren)));
        errors.push(...newProvisions.errors);
    }
    const pos = line.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const amendProvision = (0, std_1.newStdEL)("AmendProvision", {}, children, range);
    return {
        value: amendProvision,
        errors,
    };
}));
exports.default = exports.$amendProvision;
//# sourceMappingURL=$amendProvision.js.map